import React from "react";
import FormField from "./FormField";
import {
  FormControl,
  InputLabel,
  Select as MUISelect,
  MenuItem,
  FormHelperText,
} from "@mui/material";



////
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
//

const Select = React.forwardRef((props, ref) => (
  <FormField ref={ref} Component={SelectImpl} {...props} />
));

const SelectImpl = React.forwardRef(
  (
    {
      label,
      name = "",
      variant,
      size,
      value,
      onChange,
      onBlur,
      error,
      helperText,
      sx,
      defaultItem,
      items,
      nameField = "name",
      valueField = "value",
      className,
      ...restProps
    },
    ref
  ) => {
    const inputId = name.replace(".", "-");

    let menuItems = [];
    if (items) {
      if (defaultItem?.name) {
        menuItems = [defaultItem, ...items];
      } else {
        menuItems = [...items];
      }
    }

    return (
      <FormControl disabled={restProps?.disabled} variant={variant} size={size} error={error} sx={{ ...sx }} className={className}>
        <InputLabel id={`${inputId}-label`}>{label}</InputLabel>
        <MUISelect
          fullWidth
          labelId={`${inputId}-label`}
          id={inputId}
          value={value}
          onChange={(event)=>{
            onChange(event.target.value)
            restProps?.info?.handlePaymentBy(event.target.value)
            }}
          onBlur={onBlur}
          label={label}
          ref={ref}
          MenuProps={MenuProps}
        >
          {menuItems.map((item, index) => (
            <MenuItem  key={item[valueField]} value={item[valueField]}>
              {item[nameField] }
            </MenuItem>
          ))}
        </MUISelect>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
  }
);

export default Select;
